import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicAvatar from "./BasicAvatar";
import GroupAvatar from "./GroupAvatar";

const AvatarPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Avatar"}
        description={
          "Avatars are found throughout material design with uses in everything from tables to dialog menus."
        }
      />
      <Divider light />
      <BasicAvatar />
      <GroupAvatar />
    </Paper>
  );
};

export default AvatarPage;
